import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import baseUrl from "../../api/universalApi";
import ViewContract from "./ViewContract";
import toast, { Toaster } from "react-hot-toast";

const SignContract = () => {
  const [contract, setContract] = useState(null);
  const [popup, setPopup] = useState(false);
  const [form, setForm] = useState({
    signBy: "",
    aadhar: "",
    phone: "",
    otp: "",
    comment: "",
  });

  const [otpSent, setOtpSent] = useState(false);

  const useLocation = () => {
    const { pathname } = window.location;
    const pathParts = pathname.split("/");
    return {
      pathname,
      campaignId: pathParts[pathParts.length - 1],
    };
  };

  const location = useLocation();

  //console.log(location.campaignId)
  const fetchContractDetails = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/agreement/getAgreement/${location.campaignId}`
      );
      const data = await response.json();
      setContract(data);

     // console.log("Data", data);
    } catch (error) {
      console.error("Error fetching contract details:", error);
    }
  };

  useEffect(() => {
    fetchContractDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "phone" ? value.replace(/\D/g, "") : value,
    }));
  };

  const handleSendOtp = async () => {
    // Simulate API call
    await new Promise((res) => setTimeout(res, 1000));
    setOtpSent(true);
    toast.success("OTP sent successfully!", {
      position: "top-right",
      duration: 3000,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log(form);

    const payload = {
      signedBy: form.signBy,
      Adhar: form.aadhar,
      phoneNo: form.phone,
      comments: form.comment,
      agreementId: contract._id,
      campaignId: contract.campaign_id._id,
    };

    // console.log("Payload", payload);
    try {
      const res = await fetch(`${baseUrl}/api/agreement/signAgreement`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      //console.log(res);
      if (!res.ok) {
        throw new Error("Failed to sign contract");
      }
      const data = await res.json();
      console.log("Response Data", data);
      toast.success("Contract signed successfully!", {
        position: "top-right",
        duration: 3000,
      });
    } catch (error) {
      console.log("Error", error.message);
    }
  };

  return (
    <motion.div
      className="w-full bg-gray-200 mx-auto p-6 space-y-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <form onSubmit={handleSubmit} className="w-full">
        <div className="bg-white rounded shadow p-4 w-full">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium">Full Name</label>
              <input
                type="text"
                name="signBy"
                placeholder="Full Name"
                value={form.signBy}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>

            <div>
              <label className="block text-sm font-medium">Aadhar Number</label>
              <input
                type="text"
                name="aadhar"
                placeholder="RedBull"
                value={form.aadhar}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>

            <div>
              <label className="block text-sm font-medium">Phone Number</label>
              <div className="flex gap-2 items-center">
                <input
                  type="text"
                  name="phone"
                  placeholder="Enter phone number"
                  value={form.phone}
                  onChange={handleChange}
                  className="w-full border p-2 rounded"
                />
                <button
                  type="button"
                  onClick={handleSendOtp}
                  disabled={!form.phone || form.phone.length < 10}
                  className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 disabled:opacity-50"
                >
                  Send OTP
                </button>
              </div>
            </div>

            {otpSent && (
              <div>
                <label className="block text-sm font-medium">OTP</label>
                <input
                  type="text"
                  name="otp"
                  placeholder="Enter OTP"
                  value={form.otp}
                  onChange={handleChange}
                  className="w-full border p-2 rounded"
                />
              </div>
            )}

            <div>
              <h2 className="text-lg font-semibold">Agreement Review</h2>
              <button
                className="py-1 px-3 rounded-full bg-gray-300"
                onClick={() => setPopup(true)}
              >
                View Contract
              </button>
            </div>

            <div>
              <label className="block text-sm font-medium">
                Comments (Optional)
              </label>
              <textarea
                name="comment"
                placeholder=""
                value={form.comment}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>
          </div>

          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 mt-4"
          >
            Submit
          </button>
        </div>
      </form>

      <>
        {popup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center  bg-opacity-30">
            <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg p-6 relative">
              <button
                onClick={() => setPopup(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-red-600 text-xl font-bold"
              >
                &times;
              </button>
              <ViewContract />
            </div>
          </div>
        )}
      </>
    </motion.div>
  );
};

export default SignContract;
